export const isCustomMarket = (templateMarketId: string): boolean => templateMarketId.includes('custom');
